// Fronts shown on the post-login picker. Add a row here when a job gets its own surface.
// The stored choice is per browser tab and per user. Permissions do not change with the choice.

export const OPERATING_FRONTS = [
  {
    id: "sales",
    eyebrow: "Sales desk",
    title: "New sales",
    body: "The customer in front of you. Lot, price, and the next step.",
    action: "Enter sales",
  },
  {
    id: "legacy",
    eyebrow: "Current app",
    title: "Legacy",
    body: "Buckets and modes, including red iron and every other job you already run.",
    action: "Enter legacy",
  },
] as const;

export type OperatingFrontId = (typeof OPERATING_FRONTS)[number]["id"];

const STORAGE_PREFIX = "turbo.operatingFront.";

export function isOperatingFrontId(value: string | null): value is OperatingFrontId {
  return OPERATING_FRONTS.some((front) => front.id === value);
}

function memory(): Storage | null {
  try {
    return globalThis.sessionStorage ?? null;
  } catch {
    return null;
  }
}

export function operatingFrontStorageKey(userId: string): string {
  return `${STORAGE_PREFIX}${userId}`;
}

export function readOperatingFront(userId: string, store: Storage | null = memory()): OperatingFrontId | null {
  if (!store) return null;
  try {
    const raw = store.getItem(operatingFrontStorageKey(userId));
    return isOperatingFrontId(raw) ? raw : null;
  } catch {
    return null;
  }
}

export function writeOperatingFront(
  userId: string,
  front: OperatingFrontId | null,
  store: Storage | null = memory(),
): void {
  if (!store) return;
  const key = operatingFrontStorageKey(userId);
  try {
    if (front) store.setItem(key, front);
    else store.removeItem(key);
  } catch {
    /* private mode / quota */
  }
}

export function clearOperatingFronts(store: Storage | null = memory()): void {
  if (!store) return;
  try {
    const keys: string[] = [];
    for (let i = 0; i < store.length; i += 1) {
      const key = store.key(i);
      if (key?.startsWith(STORAGE_PREFIX)) keys.push(key);
    }
    for (const key of keys) store.removeItem(key);
  } catch {
    /* ignore */
  }
}
